/**
 * Wire protocol between clients and the SFU.
 *
 * Transport is a single WebSocket per peer carrying newline-free JSON frames.
 * There are exactly three frame shapes: `request`, `response`, `notification`.
 * Requests are bidirectional — the server issues `newConsumer` as a request so it
 * knows the client has created the receiving transport-side consumer before it
 * resumes the stream (this is what prevents the classic "black first frame" race).
 */
export const PROTOCOL_VERSION = 1;
/* ------------------------------------------------------------ error codes */
export const ErrorCodes = {
    BAD_REQUEST: 'BAD_REQUEST',
    UNAUTHORIZED: 'UNAUTHORIZED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    ROOM_FULL: 'ROOM_FULL',
    ROOM_LOCKED: 'ROOM_LOCKED',
    ALREADY_JOINED: 'ALREADY_JOINED',
    NOT_JOINED: 'NOT_JOINED',
    INTERNAL: 'INTERNAL',
    RATE_LIMITED: 'RATE_LIMITED',
    UNSUPPORTED: 'UNSUPPORTED',
    SCREEN_SHARE_BUSY: 'SCREEN_SHARE_BUSY',
};
export class ProtocolError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.code = code;
        this.name = 'ProtocolError';
    }
}
//# sourceMappingURL=signaling.js.map